import { when } from '@execonline-inc/maybe-adapter';
import { PaginationMetadata } from '@execonline-inc/resource';
import { Maybe } from 'maybeasy';

export const hasResults = <T extends PaginationMetadata>(metadata: T): boolean =>
  metadata.resultsCount > 0 && metadata.pageCount > 1;

export const whenHasResults = <T extends PaginationMetadata>(metadata: Maybe<T>): Maybe<T> =>
  metadata.andThen(when<T>(hasResults));

export const whenNotOnFirstPage = (metadata: PaginationMetadata): Maybe<PaginationMetadata> =>
  when(metadata.currentPage > 1, metadata);

export const whenNotOnLastPage = (metadata: PaginationMetadata): Maybe<PaginationMetadata> =>
  when(metadata.currentPage < metadata.pageCount, metadata);
